import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddDealComponent } from './add-deal/add-deal.component';





const routes: Routes = [
  {
    path: 'sgrb', 
    children: [
    {path: '', component: DashboardComponent},
    {path: 'addDeal', component: AddDealComponent },
   ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SgrbRoutingModule { }
